import { avatarAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseAvatarStyle = definePartsStyle({
  container: {
    bg: "linear-gradient(139deg, #5C6670 2.33%, #131316 96.28%)",
    color: "#ffffff",
  },
});

const avatarTheme = defineMultiStyleConfig({
  baseStyle: baseAvatarStyle,
});

export default avatarTheme;
